import i18next from 'i18next'
import { List } from 'immutable'
import once from 'lodash-es/once'
import { IOptimusService, OptimusServiceProps } from '../../../domain/optimusService'
import { ImmutableMapFactory } from '../../../types/immutableTypes'

//Delivery Orders AKA Bringeordre
//Mostly used to transport bulks of packages from terminal to PickupPoint
//On Parcel departments, this service is available for all customers
//When selected overriddenDepartmentId is set to the current department

const deliveryOrderServiceCode = 'BRINGE'

// Built on first use, not on import: this module loads at startup, before i18next has the user's language
export const deliveryOrderServices = once(
  (): List<IOptimusService> =>
    List.of(
      ImmutableMapFactory({
        id: -999999,
        serviceCode: deliveryOrderServiceCode,
        alystraServiceCode: deliveryOrderServiceCode,
        alystraArticleCode: deliveryOrderServiceCode,
        description: i18next.t('instant.booking.deliveryOrderService.description'),
        isoPickupTimeFrom: '',
        isoPickupTimeTo: '',
        isoDeliveryTimeFrom: '',
        isoDeliveryTimeTo: '',
        availableOnDays: [1, 2, 3, 4, 5, 6, 7],
        useCustomerZones: false,
        xParameter: '',
        yParameter: ''
      } as OptimusServiceProps)
    )
)

export const isDeliveryOrderService = (service: IOptimusService | null | undefined): boolean =>
  service?.get('serviceCode') === deliveryOrderServiceCode

export const isDeliveryOrderServiceCode = (serviceCode: string | null | undefined): boolean =>
  serviceCode === deliveryOrderServiceCode
